// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   LAYOUT GRID
   ------------------------------------------------------------------ */
.app-container {
    display: grid;
    grid-template-columns: 260px 1fr; /* Sidebar width + Main content */
    height: 100vh;
    position: relative;
    z-index: 1; /* Above canvas */
    transition: grid-template-columns 0.3s ease;
}

.app-container.sidebar-collapsed {
    grid-template-columns: 80px 1fr;
}

/* ------------------------------------------------------------------
   THREE.JS BACKGROUND
   ------------------------------------------------------------------ */
#canvas-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none; /* Let clicks pass through */
}

/* ------------------------------------------------------------------
   SIDEBAR
   ------------------------------------------------------------------ */
.sidebar {
    background-color: var(--sidebar-bg);
    border-right: 1px solid var(--border);
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    transition: all 0.3s ease;
    z-index: 2;
    overflow-x: hidden;
}

.sidebar.collapsed {
    padding: 1.5rem 0.75rem;
    align-items: center;
}

.sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2.5rem;
    width: 100%;
}

.sidebar.collapsed .sidebar-header {
    flex-direction: column;
    gap: 1rem;
}

.sidebar .logo {
    font-size: 1.1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--text-main);
}

.sidebar-toggle {
    background: var(--hover-bg);
    border: 1px solid var(--border);
    color: var(--text-main);
    cursor: pointer;
    padding: 6px 10px;
    border-radius: 6px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.sidebar-toggle:hover {
    background-color: var(--border);
    color: var(--accent);
    border-color: var(--accent);
}

.sidebar-toggle i {
    font-size: 0.9rem;
}

.sidebar .logo-square {
    width: 18px;
    height: 18px;
    background: var(--accent);
}

.nav-menu {
    list-style: none;
    flex: 1 1;
    padding: 0;
    margin: 0;
}

.nav-item {
    margin-bottom: 0.5rem;
}

.nav-link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0.75rem 1rem;
    color: var(--text-muted);
    text-decoration: none;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.sidebar.collapsed .nav-link {
    justify-content: center;
    padding: 0.75rem;
    color: var(--text-muted);
    width: 40px;
    height: 40px;
    margin: 0 auto;
    border-radius: 8px;
}

.sidebar.collapsed .nav-link i {
    font-size: 1.2rem;
    margin: 0;
    width: 20px;
    text-align: center;
}

.sidebar.collapsed .nav-link:hover i,
.sidebar.collapsed .nav-link.active i {
    color: var(--accent);
}

.nav-link:hover {
    background-color: var(--hover-bg);
    color: var(--text-main);
}

.nav-link.active {
    background-color: var(--hover-bg);
    color: var(--accent);
    font-weight: 600;
}

/* Dropdown icon for bots */
.nav-link .dropdown-icon {
    margin-left: auto;
    font-size: 0.7rem;
    transition: transform 0.2s;
}

/* Bots dropdown */
.bots-dropdown {
    list-style: none;
    padding: 0.25rem 0 0.25rem 1.5rem;
    margin: 0 0 0.5rem 1.4rem;
    animation: slideDown 0.2s ease-out;
    border-left: 1px solid var(--border);
    position: relative;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.bots-dropdown-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0.6rem 1rem;
    color: var(--text-muted);
    border-radius: 4px;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s;
    margin-bottom: 0.25rem;
    position: relative;
}

.bots-dropdown-item::before {
    content: '';
    position: absolute;
    left: -1.5rem;
    top: 50%;
    width: 1rem;
    height: 1px;
    background-color: var(--border);
}

.bots-dropdown-item:hover {
    background-color: var(--hover-bg);
    color: var(--text-main);
}

.bots-dropdown-item.selected {
    background-color: rgba(37, 99, 235, 0.1);
    color: var(--accent);
    font-weight: 600;
}

.bots-dropdown-item i {
    font-size: 0.75rem;
    opacity: 0.7;
}

.bots-dropdown-loading,
.bots-dropdown-empty {
    padding: 0.6rem 1rem;
    color: var(--text-muted);
    font-size: 0.85rem;
    font-style: italic;
}

.user-profile {
    padding-top: 1rem;
    border-top: 1px solid var(--border);
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--text-main);
    font-size: 0.9rem;
    transition: all 0.3s;
}

.sidebar.collapsed .user-profile {
    justify-content: center;
}

.avatar {
    width: 32px;
    height: 32px;
    background: var(--border);
    border-radius: 50%;
}

/* ------------------------------------------------------------------
   MAIN CONTENT AREA
   ------------------------------------------------------------------ */
.main-content {
    display: flex;
    flex-direction: column;
    overflow: hidden; /* For scrolling inside content */
    backdrop-filter: blur(2px); /* Slight blur of the 3D city behind */
}

/* Header */
.main-content header {
    height: 70px;
    border-bottom: 1px solid var(--border);
    background-color: var(--sidebar-bg); /* Opaque for readability */
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
    transition: background-color 0.3s;
}

.header-title h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--text-main);
    margin: 0;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

/* Toggle Switch */
.theme-toggle {
    background: none;
    border: none;
    cursor: pointer;
    color: var(--text-muted);
    font-size: 1.1rem;
    transition: color 0.2s;
    padding: 0.5rem;
}
.theme-toggle:hover { color: var(--text-main); }

.btn-signout {
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
    border: 1px solid var(--border);
    background: transparent;
    color: var(--text-main);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
}
.btn-signout:hover {
    border-color: var(--accent);
    color: var(--accent);
}

/* Content Scroll Area */
.scroll-area {
    flex: 1 1;
    overflow-y: auto;
    padding: 2rem;
    background-color: var(--bg-color);
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .app-container {
        grid-template-columns: 1fr;
    }

    .sidebar {
        display: none; /* Mobile navigation would need a different approach, maybe a drawer or bottom nav */
    }

    /* We might need to implement a mobile menu toggle if we hide sidebar */
    /* For now, let's keep the existing mobile responsiveness or adapt sidebar for mobile */
}

/* Adapting sidebar for mobile as per original app mobile support */
@media (max-width: 768px) {
    .app-container {
        grid-template-columns: 1fr;
        grid-template-rows: auto 1fr;
    }

    .sidebar {
        display: flex; /* Show sidebar on mobile but maybe simplified */
        flex-direction: row;
        align-items: center;
        padding: 1rem;
        height: auto;
        border-right: none;
        border-bottom: 1px solid var(--border);
        overflow-x: auto;
    }

    .sidebar .logo {
        margin-bottom: 0;
        margin-right: 1.5rem;
        font-size: 1rem;
    }

    .nav-menu {
        display: flex;
        gap: 0.5rem;
    }
    
    .nav-item {
        margin-bottom: 0;
    }

    .nav-link {
        padding: 0.5rem;
        font-size: 0.8rem;
        white-space: nowrap;
    }
    
    .nav-link i {
        margin-right: 5px;
    }

    .user-profile {
        display: none; /* Hide profile on mobile header to save space */
    }
    
    .main-content header {
        padding: 0 1rem;
        height: 60px;
    }
    
    .scroll-area {
        padding: 1rem;
    }
    
    /* Hide bots dropdown on mobile for simplicity */
    .bots-dropdown {
        display: none;
    }
    
    .nav-link .dropdown-icon {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/DashboardLayout.css"],"names":[],"mappings":"AAAA;;uEAEuE;AACvE;IACI,aAAa;IACb,gCAAgC,EAAE,iCAAiC;IACnE,aAAa;IACb,kBAAkB;IAClB,UAAU,EAAE,iBAAiB;IAC7B,2CAA2C;AAC/C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;uEAEuE;AACvE;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB,EAAE,4BAA4B;AACtD;;AAEA;;uEAEuE;AACvE;IACI,mCAAmC;IACnC,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,SAAO;IACP,UAAU;IACV,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,kCAAkC;IAClC,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;IACpB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,WAAW;IACX,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,oBAAoB;IACpB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;uEAEuE;AACvE;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAE,iCAAiC;IACnD,0BAA0B,EAAE,sCAAsC;AACtE;;AAEA,WAAW;AACX;IACI,YAAY;IACZ,sCAAsC;IACtC,mCAAmC,EAAE,2BAA2B;IAChE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;AACnB;AACA,sBAAsB,uBAAuB,EAAE;;AAE/C;IACI,iBAAiB;IACjB,oBAAoB;IACpB,+BAA+B;IAC/B,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA,wBAAwB;AACxB;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,iCAAiC;AACrC;;AAEA,sBAAsB;AACtB;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa,EAAE,oFAAoF;IACvG;;IAEA,uEAAuE;IACvE,uFAAuF;AAC3F;;AAEA,mEAAmE;AACnE;IACI;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;;IAEA;QACI,aAAa,EAAE,gDAAgD;QAC/D,mBAAmB;QACnB,mBAAmB;QACnB,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,sCAAsC;QACtC,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa,EAAE,gDAAgD;IACnE;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA,gDAAgD;IAChD;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* ------------------------------------------------------------------\n   LAYOUT GRID\n   ------------------------------------------------------------------ */\n.app-container {\n    display: grid;\n    grid-template-columns: 260px 1fr; /* Sidebar width + Main content */\n    height: 100vh;\n    position: relative;\n    z-index: 1; /* Above canvas */\n    transition: grid-template-columns 0.3s ease;\n}\n\n.app-container.sidebar-collapsed {\n    grid-template-columns: 80px 1fr;\n}\n\n/* ------------------------------------------------------------------\n   THREE.JS BACKGROUND\n   ------------------------------------------------------------------ */\n#canvas-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 0;\n    pointer-events: none; /* Let clicks pass through */\n}\n\n/* ------------------------------------------------------------------\n   SIDEBAR\n   ------------------------------------------------------------------ */\n.sidebar {\n    background-color: var(--sidebar-bg);\n    border-right: 1px solid var(--border);\n    display: flex;\n    flex-direction: column;\n    padding: 1.5rem;\n    transition: all 0.3s ease;\n    z-index: 2;\n    overflow-x: hidden;\n}\n\n.sidebar.collapsed {\n    padding: 1.5rem 0.75rem;\n    align-items: center;\n}\n\n.sidebar-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 2.5rem;\n    width: 100%;\n}\n\n.sidebar.collapsed .sidebar-header {\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.sidebar .logo {\n    font-size: 1.1rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: var(--text-main);\n}\n\n.sidebar-toggle {\n    background: var(--hover-bg);\n    border: 1px solid var(--border);\n    color: var(--text-main);\n    cursor: pointer;\n    padding: 6px 10px;\n    border-radius: 6px;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10;\n}\n\n.sidebar-toggle:hover {\n    background-color: var(--border);\n    color: var(--accent);\n    border-color: var(--accent);\n}\n\n.sidebar-toggle i {\n    font-size: 0.9rem;\n}\n\n.sidebar .logo-square {\n    width: 18px;\n    height: 18px;\n    background: var(--accent);\n}\n\n.nav-menu {\n    list-style: none;\n    flex: 1;\n    padding: 0;\n    margin: 0;\n}\n\n.nav-item {\n    margin-bottom: 0.5rem;\n}\n\n.nav-link {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 0.75rem 1rem;\n    color: var(--text-muted);\n    text-decoration: none;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    white-space: nowrap;\n}\n\n.sidebar.collapsed .nav-link {\n    justify-content: center;\n    padding: 0.75rem;\n    color: var(--text-muted);\n    width: 40px;\n    height: 40px;\n    margin: 0 auto;\n    border-radius: 8px;\n}\n\n.sidebar.collapsed .nav-link i {\n    font-size: 1.2rem;\n    margin: 0;\n    width: 20px;\n    text-align: center;\n}\n\n.sidebar.collapsed .nav-link:hover i,\n.sidebar.collapsed .nav-link.active i {\n    color: var(--accent);\n}\n\n.nav-link:hover {\n    background-color: var(--hover-bg);\n    color: var(--text-main);\n}\n\n.nav-link.active {\n    background-color: var(--hover-bg);\n    color: var(--accent);\n    font-weight: 600;\n}\n\n/* Dropdown icon for bots */\n.nav-link .dropdown-icon {\n    margin-left: auto;\n    font-size: 0.7rem;\n    transition: transform 0.2s;\n}\n\n/* Bots dropdown */\n.bots-dropdown {\n    list-style: none;\n    padding: 0.25rem 0 0.25rem 1.5rem;\n    margin: 0 0 0.5rem 1.4rem;\n    animation: slideDown 0.2s ease-out;\n    border-left: 1px solid var(--border);\n    position: relative;\n}\n\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.bots-dropdown-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 0.6rem 1rem;\n    color: var(--text-muted);\n    border-radius: 4px;\n    font-size: 0.85rem;\n    cursor: pointer;\n    transition: all 0.2s;\n    margin-bottom: 0.25rem;\n    position: relative;\n}\n\n.bots-dropdown-item::before {\n    content: '';\n    position: absolute;\n    left: -1.5rem;\n    top: 50%;\n    width: 1rem;\n    height: 1px;\n    background-color: var(--border);\n}\n\n.bots-dropdown-item:hover {\n    background-color: var(--hover-bg);\n    color: var(--text-main);\n}\n\n.bots-dropdown-item.selected {\n    background-color: rgba(37, 99, 235, 0.1);\n    color: var(--accent);\n    font-weight: 600;\n}\n\n.bots-dropdown-item i {\n    font-size: 0.75rem;\n    opacity: 0.7;\n}\n\n.bots-dropdown-loading,\n.bots-dropdown-empty {\n    padding: 0.6rem 1rem;\n    color: var(--text-muted);\n    font-size: 0.85rem;\n    font-style: italic;\n}\n\n.user-profile {\n    padding-top: 1rem;\n    border-top: 1px solid var(--border);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: var(--text-main);\n    font-size: 0.9rem;\n    transition: all 0.3s;\n}\n\n.sidebar.collapsed .user-profile {\n    justify-content: center;\n}\n\n.avatar {\n    width: 32px;\n    height: 32px;\n    background: var(--border);\n    border-radius: 50%;\n}\n\n/* ------------------------------------------------------------------\n   MAIN CONTENT AREA\n   ------------------------------------------------------------------ */\n.main-content {\n    display: flex;\n    flex-direction: column;\n    overflow: hidden; /* For scrolling inside content */\n    backdrop-filter: blur(2px); /* Slight blur of the 3D city behind */\n}\n\n/* Header */\n.main-content header {\n    height: 70px;\n    border-bottom: 1px solid var(--border);\n    background-color: var(--sidebar-bg); /* Opaque for readability */\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 2rem;\n    transition: background-color 0.3s;\n}\n\n.header-title h2 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: var(--text-main);\n    margin: 0;\n}\n\n.header-actions {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n/* Toggle Switch */\n.theme-toggle {\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: var(--text-muted);\n    font-size: 1.1rem;\n    transition: color 0.2s;\n    padding: 0.5rem;\n}\n.theme-toggle:hover { color: var(--text-main); }\n\n.btn-signout {\n    font-size: 0.9rem;\n    padding: 0.5rem 1rem;\n    border: 1px solid var(--border);\n    background: transparent;\n    color: var(--text-main);\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n.btn-signout:hover {\n    border-color: var(--accent);\n    color: var(--accent);\n}\n\n/* Content Scroll Area */\n.scroll-area {\n    flex: 1;\n    overflow-y: auto;\n    padding: 2rem;\n    background-color: var(--bg-color);\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n    .app-container {\n        grid-template-columns: 1fr;\n    }\n\n    .sidebar {\n        display: none; /* Mobile navigation would need a different approach, maybe a drawer or bottom nav */\n    }\n\n    /* We might need to implement a mobile menu toggle if we hide sidebar */\n    /* For now, let's keep the existing mobile responsiveness or adapt sidebar for mobile */\n}\n\n/* Adapting sidebar for mobile as per original app mobile support */\n@media (max-width: 768px) {\n    .app-container {\n        grid-template-columns: 1fr;\n        grid-template-rows: auto 1fr;\n    }\n\n    .sidebar {\n        display: flex; /* Show sidebar on mobile but maybe simplified */\n        flex-direction: row;\n        align-items: center;\n        padding: 1rem;\n        height: auto;\n        border-right: none;\n        border-bottom: 1px solid var(--border);\n        overflow-x: auto;\n    }\n\n    .sidebar .logo {\n        margin-bottom: 0;\n        margin-right: 1.5rem;\n        font-size: 1rem;\n    }\n\n    .nav-menu {\n        display: flex;\n        gap: 0.5rem;\n    }\n    \n    .nav-item {\n        margin-bottom: 0;\n    }\n\n    .nav-link {\n        padding: 0.5rem;\n        font-size: 0.8rem;\n        white-space: nowrap;\n    }\n    \n    .nav-link i {\n        margin-right: 5px;\n    }\n\n    .user-profile {\n        display: none; /* Hide profile on mobile header to save space */\n    }\n    \n    .main-content header {\n        padding: 0 1rem;\n        height: 60px;\n    }\n    \n    .scroll-area {\n        padding: 1rem;\n    }\n    \n    /* Hide bots dropdown on mobile for simplicity */\n    .bots-dropdown {\n        display: none;\n    }\n    \n    .nav-link .dropdown-icon {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
